module.exports = __webpack_public_path__ + "img/servicios3_1.dc49b3fa.png";